import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import useUser from "../../../../hooks/useUser";

export default function AppointmentShortInfo({
  title,
  date,
  type,
  petName,
  user,
  clinicName
}) {
  const { roles } = useUser();
  const isUserAdmin = roles.adminOrEmployee;
  const { t } = useTranslation();
  return (
    <Stack>
      {isUserAdmin ? (
        <Typography variant="body1" fontSize={{ xs: ".8rem", sm: ".9rem" }}>
          {user ?? t("NoInfo")}
        </Typography>
      ) : null}
      <Typography variant="subtitle2" fontSize={{ xs: ".8rem", sm: ".9rem" }}>
        {petName || t("NoInfo")}
      </Typography>
      <Typography variant="subtitle2" fontSize={{ xs: ".8rem", sm: ".9rem" }}>
        {date || t("NoInfo")}
      </Typography>
      {type ? (
        <Typography variant="subtitle2" fontSize={{ xs: ".8rem", sm: ".9rem" }}>
          {type}
        </Typography>
      ) : null}
      {clinicName ? (
        <Typography variant="subtitle2" fontSize={{ xs: ".8rem", sm: ".9rem" }}>
          {clinicName}
        </Typography>
      ) : null}
    </Stack>
  );
}
